import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { PAGE } from '../app.routes';
import { APP_CONFIG } from '../core';
import { UserRequestService } from '../services';
import { BaseComponent } from '../shared';


/**
* User request success page component.
*/
@Component({
	selector: 'success-page',
	templateUrl: './success-page.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class SuccessPageComponent extends BaseComponent implements OnInit {

	private readonly router = inject(Router);
	private readonly config = inject(APP_CONFIG);
	private readonly userSrv = inject(UserRequestService);

	readonly orthofixWebsite = this.config.orthofixWebsite;
	readonly customerCareEmail = this.config.customerCareEmail;
	readonly orthofixMedicalEducation = this.config.orthofixMedicalEducation;

	ngOnInit(): void {
		this.userSrv.successState.pipe(first()).subscribe(state => state ? null : this.router.navigateByUrl(PAGE.REQUEST));
	}

}
